import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import Home from './pages/Home'
import About from './pages/About'

function App() {
  return (
    <Router>
      <div className="min-h-screen flex flex-col" data-component-path="client/src/App.jsx" data-component-line="1:1" data-component-id="client/src/App.jsx:1:1">
        <Navbar />
        <main className="flex-grow" data-component-path="client/src/App.jsx" data-component-line="2:2" data-component-id="client/src/App.jsx:2:2">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-right" />
      </div>
    </Router>
  )
}

export default App